import { render, staticRenderFns } from "./Usa.vue?vue&type=template&id=b9f87da2&scoped=true&"
import script from "./Usa.vue?vue&type=script&lang=js&"
export * from "./Usa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f87da2",
  null
  
)

export default component.exports